<!--步骤组件-->
<template>
  <div class="steps-v2">
    <img v-if="(type === 's4') && (step === 1)" class="steps-icon" src="@/assets/pc/steps/1.png" alt="">
    <img v-if="(type === 's4') && (step === 2)" class="steps-icon" src="@/assets/pc/steps/2.png" alt="">
    <img v-if="(type === 's4') && (step === 3)" class="steps-icon" src="@/assets/pc/steps/3.png" alt="">
    <img v-if="(type === 's4') && (step === 4)" class="steps-icon" src="@/assets/pc/steps/4.png" alt="">

    <img v-if="(type === 's3') && (step === 1)" class="steps-icon" src="@/assets/pc/steps/5.png" alt="">
    <img v-if="(type === 's3') && (step === 2)" class="steps-icon" src="@/assets/pc/steps/6.png" alt="">
    <img v-if="(type === 's3') && (step === 3)" class="steps-icon" src="@/assets/pc/steps/7.png" alt="">

  </div>
</template>

<script>
  export default {
    name: "StepsV2",
    props: {
      type: {
        type: String,
        // s3 总共3步
        // s4 总共4步
        default: 's4',
      },
      step: {
        type: Number,
        default: 1
      }
    },

    data() {
      return {

      }
    }
  }
</script>

<style lang="scss">
  .steps-v2 {
    align-self: baseline;
    margin: 48px 0 0;

    img {
      width: 229px;
    }
  }
</style>